// Wrapper to make testing easier
import html2canvas from 'html2canvas';

export const h2c = (element, options) => html2canvas(element, options); // eslint-disable-line import/prefer-default-export
